import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Icon from '@xo-union/tk-component-icons';
import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import { temp_isValidAddress } from '~/glm/utils/address-utils';
import styles from './contact-info-cell.scss';

const getIconColor = contactInfo => `${styles.contactIcon} ${contactInfo ? styles.blackIcon : styles.grayIcon}`;

const ContactInfoCell = observer(({ household }) => {
  const { getAddress, contactableByPhone, contactableByEmail } = household;

  return (
    <div className={styles.contactInfo}>
      <Icon
        data-testid="contact-icon-address"
        className={getIconColor(temp_isValidAddress(getAddress))}
        name="home"
        size="md"
      />
      <Icon data-testid="contact-icon-phone" className={getIconColor(contactableByPhone)} name="phone" size="md" />
      <Icon
        data-testid="contact-icon-email"
        className={getIconColor(contactableByEmail)}
        name="email_alternate"
        size="md"
      />
    </div>
  );
});

ContactInfoCell.propTypes = {
  household: PropTypes.instanceOf(GdsHouseholdModel).isRequired,
};

export default ContactInfoCell;
